import { isAndroid, isIos, isOpenHarmony } from './const';

if (!window.cmi) {
	window.cmi = {};
}

export const AppMethod = {
	/**
	 * APP打开新页面（跳转新页面）
	 *
	 * @param { Object } param 参考文档
	 *
	 * @property { String } url 需要跳转的地址
	 * @property { Number } presentationType 0.从下往上pop  比如打开pdf   1.从左往右push} 默认是 1
	 * @property { Object } pdf 添加pdf到下载文档列表}
	 * **/
	openURL: 'openURL',

	// 设置界面样式
	setUIStyle: 'setUIStyle',

	/**
	 * APP展示toast或loading
	 *
	 * @param { Object } param 参考文档
	 *
	 * @property { String } text 提示语，有默认值
	 * @property { Number } isIndictorShow 1表示loading 0表示toast
	 * @property { Number } hideAfterSecond n秒之后自动隐藏，可调用hideTip隐藏
	 * @property { Number } userInteractionEnabled 点击遮盖层是否立即隐藏 1是,0否
	 * **/
	showTip: 'showTip',

	// APP隐藏tip
	hideTip: 'hideTip',

	// app 退出 webNative(新的方法，建议使用这个)
	goExit: 'goExit',

	// 退出登录
	logout: 'logout',

	// 获取用户信息
	getUserInfo: 'currentUserInfo',

	// 获取客户端信息
	getClientInfo: 'clientInfo',

	/**
	 * APP进入回放
	 *
	 * @param { String } pid 回放id
	 * **/
	goPlayback: 'goPlayback',

	/**
	 * APP进入路演厅
	 *
	 * @param { String } eid
	 * @param { Object } meta 路演厅参数
	 * **/
	goRoom: 'goRoom',

	/**
	 * APP进入自助会议
	 *
	 * @param { String } eid
	 * @param { Object } meta
	 * **/
	goMeeting: 'goMeeting',

	/**
	 * APP支付
	 * android 3.8.4版本新增payTypesAndroid, 只针对android, 不传安卓自动取原来默认
	 * @param { Array } payTypesAndroid :仅Android使用 [1 微信支付, 2 阿里支付, 3 银联支付, 4 进门余额,6 牛币, 8：怀新-微信支付 9：怀新-支付宝支付],
	 * @param { Array } payTypes : 仅IOS使用 [1 微信支付, 2 阿里支付, 3 银联支付, 4 进门余额, 5 苹果 ,6 牛币, 7 京东, 8：怀新-微信支付 9：怀新-支付宝支付],
	 * @param { String } pid :仅IOS使用, 兼容特殊的IOS
	 *  */
	goPay: 'goPay',

	goApplePay: 'goApplePay',

	// 课程购买
	goCourseBuy: 'goCourseBuy',

	// 实名认证
	goRealnameAuth: 'goRealnameAuth',

	// 打开评论页
	goComment: 'goComment',

	// 是否可以分享
	shareEnable: 'shareEnable',

	// 获取支持的分享类型
	getSupportedShareTypes: 'getSupportedShareTypes',

	// 网页分享
	goShare: 'goShare',

	// 带返回值二维码
	scanCode: 'scanCode',

	// 二维码
	scanQRCode: 'scanQRCode',

	// 网页调用客户端传递进度
	seekTo: 'seekTo',

	// 上传图片
	cardImageUpload: 'cardImageUpload',

	// 发送网络请求
	sendRequest: 'sendRequest',

	// 取消网络请求
	cancelRequest: 'cancelRequest',

	// 下载APP
	downloadApp: 'downloadApp',

	// 打电话
	callUp: 'callUp',

	// 滑动验证码
	captcha: 'captcha',

	// 加载评论插件
	loadCommentPlugin: 'loadCommentPlugin',

	// 卸载评论插件
	unloadCommentPlugin: 'unloadCommentPlugin',

	// 加载回放插件
	loadRecordPlugin: 'loadRecordPlugin',

	// 卸载回放插件
	unloadRecordPlugin: 'unloadRecordPlugin',

	// 人脸核身
	faceVerify: 'faceVerify',

	// 设置打开照相机类型
	setOpenCameraType: 'setOpenCameraType',

	// 是否已添加日历提醒
	isAlarmed: 'isAlarmed',

	// 添加日历提醒
	alarm: 'alarm',

	// 删除日历提醒
	deleteAlarm: 'deleteAlarm',

	// 网页发送回放章节信息到客户端
	uploadChapters: 'uploadChapters',

	// 下载回放
	downloadPlayback: 'downloadPlayback',

	// 浏览pdf
	browserPdf: 'browserPdf',

	// 浏览图片
	browserImage: 'browserImage',

	// 更新已经展示的路演数据
	putRoadshows: 'putRoadshows',

	// 上市公司变化通知
	putListCompanies: 'putListCompanies',

	// 专题变化通知
	putSpecialTopics: 'putSpecialTopics',

	// 行业变化通知
	putIndustries: 'putIndustries',

	// 券商变化通知
	putSecuritiesFirms: 'putSecuritiesFirms',

	// 分析师变化通知
	putAnalysts: 'putAnalysts',

	// 用户关注状态变更
	putUsers: 'putUsers',

	// 回放设置播放器状态
	setPlayState: 'setPlayState',

	// 回放播放器上面显示仅播放进度
	setRecordFocusProgressList: 'setRecordFocusProgressList',

	// 防盗录、截屏 1表示允许，0表示不允许
	setScreenCaptureState: 'setScreenCaptureState',

	// 唤起行为验证码 返回 code 0 表示成功 msg 错误信息
	getCaptDialogResult: 'getCaptDialogResult'
};

export const AppEvent = {
	// 接收App的socket消息回调
	onAppWebsocket: 'onAppWebsocket',

	// 回放视频进度回调
	onUpdateVideoTime: 'onUpdateVideoTime',

	// 回放视频操作回调
	videoProgressTracker: 'videoProgressTracker'
};

export const AppError = {
	NO_AUTH: -1,
	PARAMS_ERROR: -2,
	NO_SUPPORT: -3,
	CANCEL: -4,
	NO_NET: -5,
	TIMEOUT: -6,
	SERVICE_ERROR: -7,
	ERROR: -8,
	NO_CALENDAR_PERMISSION: -100,
	NO_LOGIN: -101,
	NO_PERMISSIONS: -108
};

export const AppBrowser = {
	/* 隐藏加载的动画 */
	hideViewLoadingAnimation: 1 << 0,
	/* 隐藏加载的进度条 */
	hideViewLoadingProgress: 1 << 1,
	/* 隐藏错误提示 */
	hideViewFailedPrompt: 1 << 2,
	/* 隐藏导航栏背景 */
	hideNavigationBarBackground: 1 << 3,
	/* 隐藏返回按钮 */
	hideNavigationBarBack: 1 << 4,
	/* 隐藏标题 */
	hideNavigationBarTitle: 1 << 5,
	/* 隐藏分享按钮 */
	hideNavigationBarShare: 1 << 6,

	/* 状态栏 */
	styleStatusBarDark: 0 << 8,
	styleStatusBarLight: 1 << 8,
	/* 页面背景 */
	styleViewBackgroundLight: 0 << 9,
	styleViewBackgroundDark: 1 << 9,
	/* 页面加载的动画 */
	styleViewLoadingAnimationLight: 0 << 10,
	styleViewLoadingAnimationDark: 1 << 10,
	/* 页面加载进度 */
	styleViewLoadingProgressLight: 0 << 11,
	styleViewLoadingProgressDark: 1 << 11,
	/* 页面加载失败提示 */
	styleViewFailedPromptLight: 0 << 12,
	styleViewFailedPromptDark: 1 << 12,
	/* 导航背景 */
	styleNavigationBarBackgroundLight: 0 << 13,
	styleNavigationBarBackgroundDark: 1 << 13,
	/* 返回按钮 */
	styleNavigationBarBackLight: 1 << 14,
	styleNavigationBarBackDark: 0 << 14,
	/* 标题 */
	styleNavigationBarTitleLight: 1 << 15,
	styleNavigationBarTitleDark: 0 << 15,
	/* 分享 */
	styleNavigationBarShareLight: 1 << 16,
	styleNavigationBarShareDark: 0 << 16,

	/* 滚动条 */
	styleDisabledScroll: 1 << 24
};

const getEventName = function (method) {
	let res = 'on' + method + '_';
	for (let i = 0; i < 6; i++) {
		res += parseInt(Math.random() * 10);
	}
	return res;
};

class App {
	constructor() { }

	// 消息订阅队列
	events = {};

	on(eventName, callback) {
		if (AppEvent[eventName] === undefined) {
			throw new Error('$app onEvent error: ' + eventName + ' is undefined');
		}

		if (!this.events.hasOwnProperty(eventName)) {
			this.events[eventName] = [];
		}

		this.events[eventName].push(callback);
	}

	off(eventName, callback) {
		if (this.events.hasOwnProperty(eventName)) {
			if (callback) {
				let eventList = this.events[eventName];
				let index = eventList.findIndex(handler => handler === callback);
				index >= 0 && eventList.splice(index, 1);
			} else {
				delete this.events[eventName];
			}
		}
	}

	handler(method, arg = {}) {
		let eventName = getEventName(method);

		return new Promise((resolve, reject) => {
			this.events[eventName] = { resolve, reject };

			this.invoke(method, {
				callback: 'cmi.' + eventName,
				param: arg
			});
		});
	}

	invoke(method, arg = {}) {
		arg.method = method;

		/* APP断增加 access 参数，判断第三方,值不能为空 */
		arg.access = arg.access || '1';

		// 先转为json字符串
		const postBody = JSON.stringify(arg);
		if (isAndroid || isOpenHarmony) {
			window.cmiBridge.postMessage(postBody);
		}
		if (isIos) {
			window.webkit.messageHandlers.cmiBridge.postMessage(postBody);
		}
	}
}

const app = new App();


(function initApp() {
	for (let key in AppMethod) {
		let method = AppMethod[key];
		app[key] = function (arg) {
			return app.handler(method, arg);
		};
	}

	app.install = function (Vue) {
		Vue.prototype.$app = app;
	};

	window.cmi = new Proxy(Object.assign({}, AppEvent), {
		get(target, key) {
			if (AppEvent[key]) {
				return function (...args) {
					let eventList = app.events[key];
					eventList &&
						eventList.forEach(handler => {
							handler(...args);
						});
				};
			} else if (app.events[key]) {
				return function (res) {
					let data = JSON.parse(res);
					let event = app.events[key];

					event && (Number(data.code) === 0 ? event.resolve(data) : event.reject(data));

					delete app.events[key];
				};
			} else {
				return target[key] || function () { };
			}
		},
	});
})();

export default app;
